import React, { useState, useEffect, useContext, useMemo } from "react";
import { Col, Row, Button, Form, Modal, Container, ListGroup, ListGroupItem, Card, Spinner } from "react-bootstrap";
import { useLocation, useNavigate } from 'react-router-dom';
import { getCDNImage } from '../../globals';
import { HotelContext } from "../../context/hotel";
import { useParams } from 'react-router';
import { T, TF } from "react-translator-component";
import Screen from '../../components/Screen';
import { useLanguage } from "../../hooks/useLanguage";
import usePerson from "../../hooks/usePerson";
import { usePerson as usePersonContext } from "../../context/person";
import { formatDateFromLanguage, formatDayMonth, i18nValue, qtyText, currencyFormat, priceWithoutTax } from "../../functions";
import processHtml from "../../components/processHtml";
import useBookable from "../../hooks/useBookable";
import '../../scss/_public_requests_detail.scss';
import { RelativeDate } from "./RelativeDate";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { isDemo, isHotelCGBeach, hotelShowsPriceWithoutTaxes } from "../../components/CheckIn/hotelConditions";
import usePaymentsActions from "../../hooks/usePaymentsActions";
import { serviceTypeIcon } from "../../globals";
import PaymentMethod from "../../components/PaymentMethod";


const PublicRequestDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { language: languageApp, setLanguage } = useLanguage()
  const { data: hotel, getUrlPath, currency } = useContext(HotelContext);
  const { data: person, setData: setPerson, logoutPerson } = usePersonContext();
  const { getPaymentMethods } = usePaymentsActions();
  const [requestData, setRequestData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [requestLoading, setRequestLoading] = useState(false);

  const { getRequest } = usePerson();
  const { confirmBookableReservation, cancelRequest } = useBookable();
  const [error, setError] = useState(null);
  const [showButtons, setShowButtons] = useState(true);
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [showConfirmButton, setShowConfirmButton] = useState(false);
  const [isModalPaymentLoading, setIsModalPaymentLoading] = useState(false);
  // Si la reserva tiene rememberStatus (se envió el mensaje de whatsapp), se muestra el botón de confirmación
  const [rememberStatus, setRememberStatus] = useState(false);
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showChatButton, setShowChatButton] = useState(true);

  // Obtener carrito desde requestData
  const cart = useMemo(() => {
    if (!requestData) return null;
    if (requestData.cart && typeof requestData.cart === 'string') {
      try {
        return JSON.parse(requestData.cart).items || [];
      } catch (e) {
        console.error('Error parsing cart:', e);
        return [];
      }
    }
    return requestData.cart?.items || [];
  }, [requestData]);

  // Verificar si hay imágenes en el carrito
  const showImages = useMemo(() => {
    let _showImages = false;
    if (cart && cart.length > 0) {
      _showImages = cart.reduce((res, i) => res || Boolean(i.photo), false);
    }
    return _showImages;
  }, [cart]);

  // Obtener información del carrito para cálculos (cantidad y precio)
  const cartInfo = useMemo(() => {
    if (!cart || cart.length === 0) return null;
    let totalQty = 0;
    let totalPrice = 0;
    cart.forEach(item => {
      if (item.qty) totalQty += item.qty;
      if (item.total) totalPrice += item.total;
    });
    return { qty: totalQty, total: totalPrice };
  }, [cart]);



  const [status, setStatus] = useState(null);
  useEffect(() => {
    let _status = requestData?.BookableReservation?.status;
    if (!_status) {
      _status = "validating";
    }
    setStatus(_status);
  }, [requestData]);
  
  const language = useMemo(() => {
    console.log('currentLanguage - call');
    let curr = "en-US";
    console.log('0406 person', person);
    if (person?.language) {
      curr = person?.language ?? "en-US";
    } else {
      if (languageApp) {
        curr = languageApp ?? "en-US";
      }
    }

    console.log('currentLanguage', curr);
    return curr;

  }, [languageApp, person])

  useEffect(async () => {
    if (isHotelCGBeach(hotel?.id)) {
      setShowChatButton(false);
    }
    // Solo cargar request si hay ID
    if (id) {
      setLoading(true);
      await getData(id);
      setLoading(false);
    }
    if (requestData?.BookableReservation?.rememberStatus !== null) {
      setRememberStatus(true);
    }
  }, [id]);

  useEffect(() => {
    setTimeout(async () => {
    if(id) {
        await getData(id);
      }
    }, 1500);
  }, [id]);

  useEffect(() => {    
    if(!requestLoading && person?.id && requestData && requestData?.status === "pending" && requestData?.status !== "canceled" ){
    setShowCancelButton(true);
    } else {
      setShowCancelButton(false);
    }
    if(requestData?.type != "items_sales" && rememberStatus &&showButtons && !requestLoading && person?.id && requestData && requestData?.status !== "pending" && requestData?.status !== "canceled" && requestData?.BookableReservation?.confirmed?.status !== true ){
      setShowConfirmButton(true);
    } else {
      setShowConfirmButton(false);
    }
  }, [requestData, requestLoading, person]);

  const getData = async (requestId) => {
    try {
      const res = await getRequest(requestId);
      console.log('res getRequest', res);
      if (res) {
        console.log('0406 - getRequest', res);
        setRequestData(res);
        // En caso de que se haya obtenido el person, se setea el person en el context y se guarda el token en localStorage
        if (res?.person) {
          setPerson(res?.person);
          localStorage.setItem('ViCo::token-' + hotel?.id + '-person', res?.token);
        }
      }
    } catch (error) {
      if (error.status === 401) {
         setError(error);
      }
      setRequestLoading(false);
    }
  };

  const handleLogout = () => {
    // Destruir el token del person
    const hotelCode = hotel?.code;
    if (hotelCode) {
      logoutPerson();
    }
    // Redirigir a la página pública de dashboard
    navigate(`/${hotelCode}/public/services`);
  }

  const handleClickGoToPublicDash = () => {
    navigate(getUrlPath(`/public/`), { replace: true })
  }

  const handleClickChangeUser = () => {
    logoutPerson();
    window.location.reload();
  }

  const handleClickConfirm = async () => {
    setRequestLoading(true);
    setShowButtons(false);
    const res = await confirmBookableReservation(requestData?.bookableReservationId);
    console.log('res confirmBookableReservation', res);
    if (res) {
      if (res?.data?.updateBookableReservation?.id) {
        await getData(id).then(() => {
          setRequestLoading(false);
        });
      }
      setRequestLoading(false);
    }else{
      setShowButtons(true);
    }
  }

  const handleClickCancel = async () => {
    setRequestLoading(true);
    const res = await cancelRequest(requestData?.id);
    console.log('res cancelRequest', res);
    if (res === true) {
      navigate(getUrlPath(`/public/`), { replace: true })
    }else{
      setRequestLoading(false);
    }
  }
  let hasTaxes = hotelShowsPriceWithoutTaxes(hotel?.id);

  const renderCustomizations = (item) => {
    if (!item.customizations || item.customizations.length < 1 || Object.keys(item.item.preferences).length === 0) {
      return <></>
    }
    const showOptionLabel = (item.customizations.length > 1);    
    return (
      <div className="mt-2 mb-1 text-left">
        {
          item.customizations.map((item1, index) => {
            
            // Recorrer las claves y valores del objeto
            return Object.keys(item1).map((key, idx) => {
              // console.log(`  Clave: ${key}`);
              // console.log(`  Valor: ${item1[key]}`);

              const _label = item.item.preferences[key]?.titleI18n['en-US'];
              const _value = item.item.preferences[key]?.options[item1[key]]?.valueI18n['en-US'];

              // console.log(_label);
              // console.log(_value);
              
              return(
                <div key={`customization-${key}-${item1[key]}`} className="overflow-hidden mx-1 mb-1">
                  { ((idx== 0) && showOptionLabel) && (<div className="font-weight-bold mt-2">{T('request.option')}{` ${index + 1}:`}</div>) }                  
                  <div className="d-flex w-auto mt-1 pl-1 pr-0 py-0" style={{ background: "#dee2e6" }}>
                    <div className="font-size-sm bg-light px-2" style={{ width: "100%" }}>
                      <div className="text-muted mr-2">{_label}</div>
                      <div className="font-weight-bolder text-primary">{_value}</div>
                    </div>
                  </div>
                </div>
              )
            })

          })

        }
      </div>
    )    
  }

  const handleGetPaymentMethods = async (requestId) => {
    setIsModalPaymentLoading(true);
    const response = await getPaymentMethods(requestId);
    if (response?.paymentOptions && response?.paymentOptions?.length > 0) {
      setPaymentOptions(response.paymentOptions);
      setShowPaymentModal(true);
      setIsModalPaymentLoading(false);
    }else{
      if(response?.paymentUrl){
        window.location.href = response.paymentUrl;
        setIsModalPaymentLoading(false);
      }
    }
  }

  const isRequiredPayment = () => {
    return ( isHotelCGBeach(hotel?.id) || isDemo(hotel?.id) ) && !requestData?.bookableReservationId && requestData?.type != "services_booking" && requestData?.paymentStatus != 'captured';
  }

  return (
    <Screen
      section={`public_request_detail`}
      title={String(T("public.request.title"))}
      showBackButton={true}
      backUrl={`public/`}
      hideHeader={false}
      classes="public-request-detail"
    >
      {/* <Container className="p-3 mt-4" style={{ maxWidth: 230, border: "1px solid #EEE", background: "#FFF", borderRadius: 8, marginBottom: 20 }}>
        <Row>
          <Col>
            <img className="w-100" src={getCDNImage(hotel.logo)} />
          </Col>
        </Row>
      </Container> */}

    {/* Mensaje de error para cuando el usuario no tiene permisos para ver la solicitud */}
    {loading && (
      <div className="loading text-center mt-5 p-10">
        <div  className="spinner-border"
                    role="status"
                    style={{
                      width: '2.5rem',
                      height: '2.5rem',
                      borderWidth: '0.25em',
                      color: '#B1B7C6',
                      opacity: 0.6,
                    }}
        ></div>
      </div>
    )}
      {error && error?.status === 401 && (
        <Container className="px-3 mt-4 d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
          <Row className="w-100 justify-content-center">
            <Col xs={12} md={8} lg={6}>
              <div className="error-card">
                <div className="error-icon">
                  <div className="icon-circle">
                    <svg width="40" height="40" viewBox="0 0 40 40">
                      <g fill="none" fillRule="evenodd">
                        <circle fill="#fff" cx="20" cy="20" r="20"/>
                        {/* Candado SVG */}
                        <rect x="11" y="18" width="18" height="12" rx="3" fill="#FF5A5F"/>
                        <path d="M14 18v-3a6 6 0 1 1 12 0v3" stroke="#FF5A5F" strokeWidth="2" fill="none"/>
                        <circle cx="20" cy="24" r="2" fill="#fff"/>
                        <rect x="19.25" y="24" width="1.5" height="4" rx="0.75" fill="#fff"/>
                      </g>
                    </svg>
                  </div>
                  <h3>
                    {T("public.request.forbidden.title")}
                  </h3>
                </div>
                  <div className="error-description">
                    {TF("public.request.forbidden.description", [person?.fullname])}
                  </div>
                <button 
                  className="btn btn-success w-100"
                  onClick={handleClickChangeUser}
                >
                  {T("public.request.forbidden.continue-button")}
                </button>
                <button 
                  className="btn btn-secondary w-100 mt-3"
                  onClick={handleClickGoToPublicDash}
                >
                  {T("public.request.forbidden.button")}
                </button>

              </div>
            </Col>
          </Row>
        </Container>
      )}

      {!loading && !requestData && !error && (
        <Container className="px-3 mt-4">
          <Row>
            <Col className="text-center">
              <div>{T("public.request.not-found")}</div>
            </Col>
          </Row>
        </Container>
      )}
      
      {requestData && (
        <>
        {requestData?.type == "items_sales" && (
         <div className="text-center">
            <div className="my-3">
              <div className="mb-2" style={{ display: 'inline-block', padding: 15, verticalAlign: 'text-top', background: '#FFF', borderRadius: '50%', border: '1px solid #EEE' }}>
                {serviceTypeIcon(isHotelCGBeach(hotel?.id) ? 'beach_service' : requestData?.type, 50)}
                </div>
              <h5 className="mb-3">{T(`services.type.${isHotelCGBeach(hotel?.id) ? 'beach_service' : requestData?.type}`)}</h5>
              <span className={`label label-lg label-light-${requestData?.status} label-inline text-uppercase mb-2 d-inline-block`}>{T(`services.status.${requestData?.status}`)}</span>
            </div>
          </div>
        )}
          {isRequiredPayment() && (<>
            <div className="text-center m-3">
              <div className="alert alert-danger" style={{ textAlign: 'center', fontSize: '12px', marginBottom: '0px' }}>
                {T("public.request.payment-status.not-captured")}
              </div>
              <Button variant="payment" onClick={() => { handleGetPaymentMethods(requestData?.id) }} disabled={requestLoading}>
                {isModalPaymentLoading ? <Spinner animation="border" size="sm" className="mb-1" /> : T("public.request.payment-status.pay-again")}  
              </Button>
            </div>
          </>)}

        {/* Modal para seleccionar método de pago */}
        <Modal show={showPaymentModal} centered backdrop="static" onHide={() => !requestLoading && setShowPaymentModal(false)}>
          <Modal.Header style={{
            display: requestLoading ? "none" : "flex",
            background: "#82378A",
            justifyContent: "space-around",
            color: "#FFFFFF",
          }} className="modal-header-center">
            <Modal.Title className="ms-auto">
              <span className="modal-title-text">
                {T("general.payment-method")}
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {paymentOptions.length > 0 && (
              <PaymentMethod 
                requestId={requestData?.id}
                paymentOptions={paymentOptions}
                loading={requestLoading}
              />
            )}
          </Modal.Body>
          <Modal.Footer style={{
            display: requestLoading ? "none" : "flex",
          }} className="modal-footer-spaced">
            <div>
              <small className={`modal-back-link ${requestLoading ? 'disabled' : ''}`} onClick={() => !requestLoading && setShowPaymentModal(false)}>
                {T("general.back")}
              </small>
            </div>
          </Modal.Footer>
          {requestLoading && (
            <div style={{ height: 150, paddingTop: 30 }}>
              <div className="processing-modal text-center">
                <div style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
                  <Spinner animation="border" />
                </div>
                <p className="processing-text">
                  {T('general.processing-request')}
                </p>
              </div>
            </div>
          )}
        </Modal>

         
          {requestData?.data?.service && (
            <Container style={{ maxWidth: 500, textAlign: "center"}}>
              <Row className="justify-content-center">
                <Col xs={12}>
                  <div 
                    className="request-detail-card"
                  >
                    {/* Contenedor con imagen */}
                    <div 
                      className="card-image"
                      style={{
                        backgroundImage: requestData?.data?.service?.photo 
                          ? `url(${getCDNImage(requestData?.data?.service?.photo)})`
                          : "none",
                      }}
                    >
                      <div className="image-overlay" />
                    </div>

                    <div className="card-content">
                      {/* Nombre del servicio */}
                      <h2>
                        {i18nValue(requestData?.data?.service, 'name', language)}
                      </h2>

                      {/* Descripción */}
                      <div className="service-description">
                        {processHtml(i18nValue(requestData?.data?.service, 'description', language))}
                      </div>
                    </div>
                  </div>

                      <div className="card-content-info-container">
                      <div className="card-content-info">
                      {/* Información de pasajeros y fecha */}
                      <div className="info-row">
                        <div className="info-col">
                          <div className="info-value">
                            {T("public.request.passengers")}
                          </div>
                          <div className="info-label">
                            {qtyText(requestData?.data?.qty, parseInt(requestData?.data?.qtyAdults), parseInt(requestData?.data?.qtyChildren))}
                          </div>
                        </div>
                        <div className="info-col info-col-right">
                          <div className="info-value">
                            {T("public.request.date-and-hour")}
                          </div>
                          <div className="info-label">
                            {requestData?.data?.day && requestData?.data?.hour
                              ? formatDateFromLanguage(`${requestData?.data?.day} ${requestData?.data?.hour}`, language)
                              : "—"
                            }
                          </div>
                        </div>
                      </div>


                      {(requestData?.data?.observations || requestData?.observations) && (<>
                        <div className="separator"></div>
                        <div className="observations-card">
                          {requestData?.data?.observations || requestData?.observations && (
                            <div>
                              <div className="obs-label">
                                {T("public.request.observations")}
                              </div>
                              <div className="obs-text">
                                {requestData?.data?.observations || requestData?.observations}
                              </div>
                            </div>
                          )}
                        </div>
                      </>)}

                      </div>
                      </div>
                </Col>
              </Row>
            </Container>
          )}

          {/* Mostrar delivery point si existe */}
          <Container style={{ maxWidth: 500, textAlign: "center", ...(isRequiredPayment() ? { opacity: 0.4, filter: "blur(2px)" } : {}) }}>
            {requestData?.deliveryPoint && (
              <Row className="justify-content-center mt-2">
                <Col xs={12}>
                  <div style={{ background: '#FFF0A8', borderRadius: 8, textAlign: 'center', padding: '5px 15px', border: '1px solid #E8D36C' }}>
                    <small>
                      {T('request.delivery-point')}
                    </small>
                    <h5>{String(requestData?.deliveryPoint).toUpperCase()}</h5>
                  </div>
                </Col>
              </Row>
            )}

            {/* Mostrar carrito si existe */}
            {cart && cart?.length > 0 && (
              <Row className="justify-content-center">
                <Col xs={12}>
                  <ListGroup className="shadow my-3 general-text-sm">
                    {cart.map((r, idx) => {
                      return (
                        <ListGroupItem key={`item-${idx}`} className="p-3">
                          <div className="d-flex">
                            {console.log('item', r)}
                            {(showImages && r.photo) && (
                              <div style={{ flex: '0 0 50px' }} className="flex-shrink-0 mt-1 mr-2">
                                <div className="image-cover" style={{ height: 50, width: 50, backgroundImage: r.photo ? `url(${getCDNImage(r.photo)})` : "none" }}></div>
                              </div>
                            )}

                          <div style={{ flexGrow: 1 }} className="">
                            <div className="d-flex justify-content-between align-items-center">
                              <span>{r.qty}x</span>
                                 <div className="d-flex justify-content-between flex-column">
                                    <h4 className="text-primary font-size-sm mb-0">
                                      <div className="float-right font-weight-bold text-uppercase font-size-sm">{ currencyFormat(r.price, currency) }</div>
                                    </h4>
                                    {hasTaxes && (
                                        <div className="font-size-sm" style={{ fontSize: "0.68rem", fontStyle: "italic", color: "#5a5a5a" }}> {T("menu.price_without_taxes")}: { currencyFormat(priceWithoutTax(r.price), currency) }</div>
                                      )}
                                  </div>
                              </div>
                            <div className="mb-1 font-weight-bold text-uppercase font-size-sm" style={{ textAlign: 'left' }}>{i18nValue(r?.item, 'name', language) || r?.item?.name}</div>
                            <p className="mb-0 text-muted" style={{ fontSize: 12, lineHeight: 1, maxHeight: 25, overflow: "hidden", textOverflow: "ellipsis" , textAlign: 'left' }}>{i18nValue(r?.item, 'description', language) || r?.item?.description}</p>
                            {/* <p className="mb-0 font-size-sm">{T('general.price')}: {currency} {r.price}</p> */}
                            { renderCustomizations(r) }                            
                          </div>
                          </div>
                        </ListGroupItem>
                      );
                    })}
                    {cartInfo && (
                      <Card className="border-0">
                        <Card.Body className="font-size-sm">
                            {requestData?.observations && (
                            <div className="mb-1 text-left">
                              <div className="font-weight-bold">{T('request.observations')}</div>
                              <div>{requestData.observations}</div>
                            </div>
                          )}
                          <div className="border-bottom my-2"></div>
                          <div className="d-flex justify-content-between font-size-md">
                            <span className="font-weight-bold">{T("general.total")}:</span>
                            <span className="font-weight-bold">{ currencyFormat(cartInfo.total, currency) }</span>
                          </div>
                        </Card.Body>
                      </Card>
                    )}
                  </ListGroup>
                </Col>
              </Row>
            )}

            {/* si la solicitud fué confirmada mostrar un cartel de confirmación */}
            {requestData?.BookableReservation?.confirmed?.status == true && (
              <div className="text-center mt-2">
                <div className="alert alert-success" style={{ textAlign: 'center', fontSize: '12px', marginBottom: '0px' }}>
                  {T("public.request.confirmed")}&nbsp;
                  <RelativeDate date={requestData?.BookableReservation?.confirmed?.date} lang={language} />
                </div>
              </div>
            )}

            {!error && status && requestData?.status !== "accepted" && requestData?.status !== "canceled" && requestData?.status !== "done" && (
              <div className="text-center mt-2">
                <div className="alert alert-warning" style={{textAlign: 'center', fontSize: '12px', marginBottom: '0px'}}>
                  {T(`public.request.status.validating-msg`)}
                </div>
              </div>
            )}

            {requestData?.status === "canceled" && (
              <div className="text-center mt-2">
                <div className="alert alert-danger" style={{ textAlign: 'center', fontSize: '12px', marginBottom: '0px'}}>
                  {T(`public.request.status.canceled-msg`)}
                </div>
              </div>
            )}
          </Container>
        </>
      )}      
        {requestLoading && (
          <div className="loading text-center mt-5 p-10">
            <div className="spinner-border" role="status"></div>
          </div>
        )}
        <div className="footer-container">
          <Row>
          {showCancelButton && (
            <Col xs={showChatButton ? 6 : 12}>
              <Button
                block={true}
                size={'lg'}
                className="pr-1"
                onClick={(e) => handleClickCancel()}
                variant={'danger'}
              >
                <FontAwesomeIcon icon={faTimesCircle} className="mr-1" /> {T("public.request.cancel-request")}
              </Button>
            </Col>
          )}
            {showChatButton && (
            <Col xs={showCancelButton ? 6 : showConfirmButton ? 4 : 12}>
                <Button
                  size={'lg'}
                  variant={'primary'}
                  type={'button'}
                  block={true}
                  onClick={() => { navigate(`messages`) }}
                >
                  <FontAwesomeIcon icon={faComment} className="mr-1" /> {T("general.chat")}
                </Button>
              </Col>
            )}
              {showConfirmButton && (
                <Col xs={8}>
                  <Button
                    block={true}
                    size={'lg'}
                    className="w-100 btn-accept btn-confirm-assistance"
                    onClick={(e) => handleClickConfirm()}
                    variant="secondary"
                  >
                    {String(T("public.request.confirm-assistance"))?.toUpperCase()}
                  </Button>
                </Col>
              )}
          </Row>
        </div>
    </Screen>
   
  );
}

export default PublicRequestDetail;

